
import React from 'react';
import { Skeleton } from '@/components/ui/skeleton';

const ChapterSkeleton: React.FC = () => (
  <div className="pulse-container min-h-[var(--app-height)] overflow-y-auto min-h-[var(--app-height)] overflow-y-auto">
    <div className="fixed top-0 left-0 right-0 bg-white z-10">
      <div className="flex items-center justify-between py-4 px-4">
        <div className="flex items-center">
          <div className="w-6 h-6 mr-4" />
          <Skeleton className="h-6 w-32" />
        </div>
        <Skeleton className="h-6 w-6" />
      </div>
    </div>
    
    <div className="pt-16 pb-20 px-4">
      <Skeleton className="h-4 w-full mb-4" />
      <Skeleton className="h-4 w-full mb-4" />
      <Skeleton className="h-4 w-3/4 mb-4" />
      <Skeleton className="h-4 w-full mb-4" />
      <Skeleton className="h-4 w-5/6 mb-4" />
      <Skeleton className="h-4 w-full mb-4" />
    </div>
    
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 z-10">
      <div className="flex justify-between items-center p-4">
        <Skeleton className="h-10 w-10" />
        <Skeleton className="h-10 w-32 rounded-full" />
        <Skeleton className="h-10 w-10" />
      </div>
    </div>
  </div>
);

export default ChapterSkeleton;
